// Port of api/fuel/app/classes/filter/search/games/sorts/query/play/plays/time.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'time',
	post: false,
	require: function(config, filter) { return sorted('time', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('COALESCE(SUM(p.play_length), 0)', sortReverse('time', filter), sortPriority('time', filter))
	}
}
